import React from 'react';
import { Controller } from 'react-hook-form';
import { ClipLoader } from 'react-spinners';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import useBusinessDataDialogHooks from './busineessDataDialog-hook';
import FileUploader from '../../../../../../Components/FileUploader/fileUploader';
import AuthInput from '../../../../../../Components/Inputs/AuthInput/authInput';
import AutoComplete from '../../../../../../Components/Inputs/AutoComplete/autoComplete';
import { customersCount } from '../../../../../../Costants/costants';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import { EditData } from '../../../../../../Assets/Icons';
import styles from './businessDialog.module.scss';

export interface IEditBusiness {
    onUpdate: () => void,
    data: ICompanyResponse,
    onCloseDialog: () => void
}

const BusinessDataDialog: React.FC<IEditBusiness> = (props) => {
    const { data, onCloseDialog } = props;
    const { t, baseURL } = useGeneralHooks();
    const {
        errors,
        register,
        control,
        imageUrl,
        dialogRef,
        country,
        onEdit,
        isFormChanged,
        setCountry,
        isLoading,
        imageLoading,
        setValue,
        handleFileInputChange,
    } = useBusinessDataDialogHooks(props);

    return (
        <div className={styles.container} ref={dialogRef} >
            <div className={styles.header}>
                <img src={EditData} alt='editData.svg' />
                <p>
                    {t('My_Business.Business_Dialog.Header')}
                </p>
            </div>
            <form className={styles.form}>
                <div className={styles.item}>
                    <div className={styles.uploadContainer}>
                        <div className={styles.label}>
                            <p>{t('Business.Step_3.Title')}</p>
                        </div>
                        <div className={styles.imageBox}>
                            {
                                imageLoading
                                    ?
                                    <ClipLoader color="#aa002b" size={40} />
                                    :
                                    <img
                                        src={imageUrl ?? `${baseURL}${data.logo}`}
                                        alt={`${imageUrl}.png`}
                                        className={styles.image}
                                    />
                            }
                        </div>
                        <FileUploader
                            id='logo'
                            handleFileInputChange={handleFileInputChange}
                            buttonTitleStyle={styles.buttonTitle}
                            buttonStyle={`${styles.uploadButton}`}
                        />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                            {t('Business.Title')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName='name'
                        labelStyle={styles.inputLabel}
                        error={errors.name}
                        patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                    />
                </div>

                <Controller
                    name="country"
                    rules={{
                        required: t('Errors.Required'),
                    }}
                    render={({ field: { name, onChange, value } }) => (
                        <div className={styles.item}>
                            <div className={styles.label}>
                                <p>
                                    {t('Business.Country')}
                                </p>
                            </div>
                            <CountryDropdown
                                defaultOptionLabel="Select Country"
                                name={name}
                                value={value}
                                onChange={(value) => {
                                    onChange(value)
                                    setCountry(value)

                                }}
                                valueType='full'
                            />
                        </div>
                    )}
                    control={control}
                />
                <Controller
                    name="city"
                    rules={{
                        required: t('Errors.Required'),
                    }}
                    render={({ field: { name, onChange, value } }) => (
                        <div className={styles.item}>
                            <div className={styles.label}>
                                <p>
                                    {t('Business.City')}
                                </p>
                            </div>
                            <RegionDropdown
                                country={country!}
                                disableWhenEmpty
                                defaultOptionLabel={t('Business.City_Plh')}
                                name={name}
                                value={value}
                                onChange={onChange}
                                valueType='full'
                            />
                        </div>
                    )}
                    control={control}
                />
                <Controller
                    control={control}
                    name='customer_count'
                    rules={{
                        required: t('Errors.Required'),
                    }}
                    render={({ field: { onChange, name, value } }) => {
                        return (
                            <div className={styles.item}>
                                <div className={styles.label}>
                                    <p>
                                        {t('Business.Average_Customers')}
                                    </p>
                                </div>
                                <AutoComplete
                                    value={value}
                                    name={name}
                                    onChange={(value) => {
                                        onChange(value)
                                        setValue('customer_count', value!)
                                    }}

                                    data={customersCount}
                                    error={errors.customer_count}
                                />
                            </div>
                        );
                    }}
                />
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Close')}
                        type='button'
                        onClick={onCloseDialog}
                        buttonStyle={styles.closeButton}
                    />
                    <Button
                        buttonType={(isFormChanged || imageUrl) ? ButtonTypes.Primery : ButtonTypes.Disabled}
                        title={t('Buttons.Save')}
                        type='button'
                        onClick={onEdit}
                        isLoading={isLoading}
                        buttonStyle={styles.button}
                        disable={!isFormChanged}
                    />
                </div>
            </form>
        </div>
    )
}

export default BusinessDataDialog
